var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: _vm.iconClass,
      style: _vm.iconStyle,
      on: {
        mouseenter: function($event) {
          _vm.isHover = true
        },
        mouseleave: function($event) {
          _vm.isHover = false
        }
      }
    },
    [
      _c("use", {
        attrs: {
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "xlink:href": _vm.iconName
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }